import React from 'react';
import { alertMessagesAdmin } from 'utils/constants';
import { texts } from 'utils/languages/fr';
import { Typography, Box } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    docStatusVerified: {
        color: theme.palette.success.main,
    },
    docStatusFailed: {
        color: theme.palette.error.main,
    },
}));

const DocumentStatus = ({ status }) => {
    const classes = useStyles();

    const getDocumentStatus = () => {
        if (status.verified) {
            return (
                <Typography className={classes.docStatusVerified} component="span" display="block">
                    {texts.DOCUMENT_VERIFIE}
                </Typography>
            );
        } else {
            return status.alerts.map(alert => {
                switch (alert.message) {
                    case 'id_check.transaction.initiated':
                    case 'id_check_secondary.transaction.initiated':
                    case 'address_check.transaction.initiated':
                        return (
                            <Typography key={alert.id} component="span" display="block">
                                {texts.ATTEND_PROCESS}
                            </Typography>
                        );
                    case 'id_check.empty_response':
                    case 'id_check_secondary.empty_response':
                    case 'address_check.empty_response':
                        return (
                            <Typography
                                key={alert.id}
                                className={classes.docStatusFailed}
                                component="span"
                                display="block"
                            >
                                {texts.JUMIO_EMPTY_RESPONSE}
                            </Typography>
                        );
                    default:
                        return (
                            <Typography
                                key={alert.id}
                                className={classes.docStatusFailed}
                                component="span"
                                display="block"
                            >
                                {alertMessagesAdmin[alert.message]}
                            </Typography>
                        );
                }
            });
        }
    };

    return status ? <Box flex="1">{getDocumentStatus()}</Box> : null;
};

export default DocumentStatus;
